<div class="container">
  <component-top-navigation></component-top-navigation>
  <div *ngIf="showWarning" class="url-override-warning">
    Runway v4 url is current overriden at {{ v4Url }}. &nbsp;<a href="/v4-debug?redirect-url=/looks">reset</a>
  </div>
  <runway-v4></runway-v4>
</div>
